import { offerTabsInit } from "../modules/offer/tabs.js";
import { onDocumentLoaded } from "../utils/on-document-loaded.js";


onDocumentLoaded(() => {
    console.log("[offer-page.js inited]");

    offerTabsInit();
});
